"use client";

import { ThemeProvider } from "next-themes";

export default function TermsLayout({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" storageKey="app-theme" enableSystem>
      {children}
    </ThemeProvider>
  );
}
